module.exports = __webpack_public_path__ + "img/glyxyfs.63a0c3ba.png";